module.exports = __webpack_public_path__ + "static/img/gs8.b222e307.jpg";